export enum ButtonAppearance {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHT = 'light',
}
